import moment from 'moment';
import jwtDecode from 'jwt-decode';
import tenantRoles from './tenantRoles';

const namespacePrefix = 'https://admin.zermattdigital.com/';
const accessTokenKey = '6zPlDkYVf9';

class Auth {
  sessionListeners = [];
  token;
  user;

  constructor() {
    const token = localStorage.getItem(accessTokenKey);
    if (this.isTokenValid(token)) {
      this.token = token;
      this.user = this.parseToken(token);
    } else {
      localStorage.removeItem(accessTokenKey);
    }
  }

  addSessionChangeListener(listener) {
    this.sessionListeners.push(listener);
  }
  removeSessionListener(listener) {
    this.sessionListeners = this.sessionListeners.filter(
      activeListener => activeListener !== listener
    );
  }

  isTokenValid(accessToken) {
    if (!accessToken) {
      return false;
    }
    try {
      const decoded = jwtDecode(accessToken);
      const expiresAt = moment(decoded.exp * 1000);
      if (expiresAt.isBefore(moment())) {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  parseToken = accessToken => {
    const decoded = jwtDecode(accessToken);
    const expiresAt = moment(decoded.exp * 1000);

    const email = decoded[namespacePrefix + 'email'];
    const roles = decoded[namespacePrefix + 'roles'];
    if (!email || !roles) {
      return;
    }
    return {
      email,
      roles: JSON.parse(roles),
      expiresAt: expiresAt.toISOString(),
    };
  };

  getAccessToken() {
    return this.token;
  }
  setSession(token) {
    localStorage.setItem(accessTokenKey, token);
    this.token = token;
    this.user = this.parseToken(token);
    this.sessionListeners.forEach(listener => listener(this.user));
    return this.user;
  }
  clearSession() {
    this.token = null;
    this.user = null;
    this.sessionListeners.forEach(listener => listener(this.user));
    localStorage.removeItem(accessTokenKey);
  }

  getUserSession() {
    return this.user;
  }

  isSessionExpired() {
    if (!this.user) {
      return true;
    }
    return moment(this.user.expiresAt).isBefore(moment());
  }

  isAuthorized = roles => {
    return this.user
      ? !this.isSessionExpired() &&
          this.user.roles.includes(tenantRoles.ADMIN) &&
          (roles.length === 0 ||
            roles.some(role => this.user.roles.includes(role)))
      : false;
  };
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/auth/Auth.js